<script setup lang="ts">
import InputText from 'primevue/inputtext'

const props = defineProps<{
    modelValue?: string
    placeholder?: string
    type?: string
    disabled?: boolean
    invalid?: boolean
    autocomplete?: string
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
}>()

function onInput(e: Event) {
    emit('update:modelValue', (e.target as HTMLInputElement).value)
}
</script>

<template>
    <InputText
        :model-value="props.modelValue"
        :placeholder="placeholder"
        :type="type ?? 'text'"
        :disabled="disabled"
        :invalid="invalid"
        :autocomplete="autocomplete"
        @input="onInput"
    />
</template>
